export const PROJECT_CLUSTER_PANEL_DICTIONARY = {
  newHousingProjects: "New Housing Projects",
  projectNameColumn: "PROJECT NAME",
  projects: "Projects",
  units: "Units",
} as const;

export const PROJECT_PANEL_BACK_DICTIONARY = {
  backToProjectList: "Back to project list",
} as const;
